export default __webpack_public_path__ + "static/media/scenario_tree.c55b5a93.png";